import React from 'react';
import clsx from "clsx";
import SaveCartLogo from "./SaveCartLogo";
import SaveCartHeadline from "./SaveCartHeadline";
import {getSaveCartConfig} from "../services/saveCartLogic";
import ValidationError from "../components/ValidationError";

export default function AutomaticSaveCartForm({
  config,
  form, // react-hook-form
  flavour,
  saveCartStatus = {},  // open, openedAt, flavour
  shoppingCart,
  ...props
}) {
  flavour ||= saveCartStatus.flavour || 'fallback';
  config ||= getSaveCartConfig(flavour);

  const {register, watch, formState} = form; // react-hook-form

  return <div className="">
    <div className="lg:px-8 lg:py-2">
      <SaveCartLogo saveCartStatus={saveCartStatus}/>

      <SaveCartHeadline
        config={config}
        saveCartStatus={saveCartStatus}
        shoppingCart={shoppingCart}/>

      <div className="px-8 lg:px-12">

        <p className="my-4">{config.prompt}</p>

        <input type="email"
          placeholder={config.emailPlaceholder || "Email Address"}
          className="text-gray-600"
          autoComplete="email"
          {...register('email',
            {required: {value: true, message: config.emailError}})}
        />

        <ValidationError form={form}/>

        <input className={clsx(config.buttonClasses || "text-white bg-brand-orange")}
          type="submit" value={config.buttonLabel || "Save Cart"}/>
      </div>
    </div>
  </div>
}

// style={{xxwidth: '800px'}}>
